import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { format } from "date-fns";
import { useDeviceContractInfo } from "@/hooks/use-device-contract-info";

interface ContractStatusCardProps {
  deviceId: string;
}

export const ContractStatusCard = ({ deviceId }: ContractStatusCardProps) => {
  const {
    totalYears,
    currentYear,
    totalContractCredits,
    nextRenewalDate,
    isMultiYear,
    isLoading,
  } = useDeviceContractInfo(deviceId);

  // Don't show the card if there's no contract data
  if (isLoading || totalContractCredits === 0) {
    return null;
  }

  return (
    <Card className="bg-muted/30 shadow-sm">
      <CardHeader className="py-3">
        <div className="flex items-center gap-2">
          <FileText className="h-4 w-4 text-brand-500" />
          <h3 className="font-medium text-sm">Contract Status</h3>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-1 gap-2 text-xs">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Duration:</span>
            <span className="font-medium">
              {totalYears} {totalYears === 1 ? 'Year' : 'Years'}
            </span>
          </div>
          
          {isMultiYear && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Current Year:</span>
              <span className="font-medium">
                Year {currentYear} of {totalYears}
              </span>
            </div>
          )}
          
          
          
          {isMultiYear && nextRenewalDate && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Next Renewal:</span>
              <span className="font-medium text-blue-600">
                {format(nextRenewalDate, 'd MMM yyyy')}
              </span>
            </div>
          )}
          
          <div className="flex justify-between">
            <span className="text-muted-foreground">Status:</span>
            <span className="font-medium text-green-600">Active</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
